import { isEqual } from "lodash";
import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";

export const useInitializeStoredCourseBucketFilter = (
  facilityId: string | null,
  courseBucketIds: string[],
  setCourseBucketIds: (courseBucketIds: string[]) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);

  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }

    const loadFilters = async () => {
      try {
        const storedCourseBucketFilter = await getFiltersFromStorage(
          `x-whoosh-${facilityId}-course-bucket-filter`
        );

        const storedCourseBucketIds = storedCourseBucketFilter
          ? storedCourseBucketFilter
              .split(",")
              .map((id) => id.trim())
              .filter((id) => id.length > 0)
          : [];

        if (
          storedCourseBucketIds.length > 0 &&
          !isEqual(storedCourseBucketIds, courseBucketIds)
        ) {
          setCourseBucketIds(storedCourseBucketIds);
        }
      } catch (error) {
        setFilterLoaded(true);
      }
    };
    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [facilityId, courseBucketIds, setCourseBucketIds, filterLoaded]);

  return filterLoaded;
};
